import React from "react";
import { Outlet, Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

const PrivateRoute = ({ redirectPath }) => {
  const { auth, loading } = useAuth();
  const location = useLocation();

  if (loading || !auth) {
    return (
      <div className="katch-loader-overlay">
        <div className="katch-spinner" />
      </div>
    );
  }

  if (!auth.isAuthenticated) {
    localStorage.setItem(
      "redirectAfterLogin",
      location.pathname + location.search,
    );
    return <Navigate to={redirectPath} state={{ from: location }} replace />;
  }

  return <Outlet />;
};

// --- Exported Guards ---
export const MemberPrivateRoute = () => (
  <PrivateRoute redirectPath="/sign-in" />
);

export const CreatorPrivateRoute = () => (
  <PrivateRoute redirectPath="/sign-in" />
);